/**
 * Declared vocabularies for the long channel's closed attributes, as held in DynamicFeatures.
 *
 * Every long-channel descriptor reads them from here, so a value, the label shown for it and the
 * icon it carries are declared once and the filter panel cannot drift from the form.
 *
 * `icon` is a key of ICON_BY_NAME. `color` is optional: without it the tint is derived from the
 * stored value, so a value added tomorrow is coloured without anyone choosing one.
 */

export const SEGMENT_OPTIONS = [
  { value: 'Auto', label: 'Auto', icon: 'DirectionsCarFilledRounded' },
  { value: 'Casa', label: 'Casa', icon: 'CottageOutlined' },
  { value: 'Salute', label: 'Salute', icon: 'LocalHospitalOutlined' },
  { value: 'Arredamenti', label: 'Arredamenti', icon: 'ChairOutlined' },
  { value: 'Altro', label: 'Altro', icon: 'Widgets' },
];

export const DEALERSTATE_OPTIONS = [
  { value: 'AT', label: 'Attivo', color: 'success.light' },
  { value: 'PE', label: 'Pending', color: 'warning.light' },
  { value: 'CH', label: 'Chiuso', color: 'error.light' },
  { value: 'SC', label: 'Sviluppo Commerciale', color: 'info.light' },
];

export const DEALERRATING_OPTIONS = [
  { value: '1', label: 'Piccolo' },
  { value: '2', label: 'Medio' },
  { value: '3', label: 'Grande' },
];

/** The values a flag attribute takes; labels are react-intl message keys. */
export const FLAG_OPTIONS = [
  { value: 'true', label: 'YES' },
  { value: 'false', label: 'NO' },
];
